import { getInput } from 'utils'

export default function getValue(name: string) {
  return getInput(name)?.value
}
